module.exports = __webpack_public_path__ + "img/shangwu.72eb34b8.png";